import React from 'react';
import "./Leadership.css";
import { getStoredData } from '../../JsonFiles/fetchData';
import IntroTemplate from "../../components/IntroTemplate/IntroTemplate";
import LearnAbout from "../../components/LearnAbout/LearnAbout";
import KeyMembers from "../../components/KeyMembers/KeyMembers.js";

const Leadership = () => {
  const data = getStoredData()?.["14"] ?? {};

  return (
    <div className="leadership-container">
      <IntroTemplate logo={data.logo} title={data.title} image={data.image} />
      <KeyMembers teamData={data.Team}/>
      <LearnAbout 
        links={data.QuickLinks} 
        title={data.AboutTitle} 
        button={data.AboutButton} 
        Link={data.AboutRedirectLink} 
      />
    </div>
  );
};

export default Leadership;
